import React from "react";

const Stat_Hyp_Testing_Proportion_Two_Tailed = () => {
  return (
    <div>
      <h1>Stat Hyp. Testing Proportion (Two Tailed)</h1>
    </div>
  );
};

export default Stat_Hyp_Testing_Proportion_Two_Tailed;
